export enum ClientStatusEnum {
  Active = 'Ativo',
  Inactive = 'Inativo',
  Converted = 'Convertido',
  ConversionFailed = 'Falha na conversão',
}
